import { AfterViewInit, Directive, ElementRef, NgZone, OnDestroy, OnInit, Optional, Renderer2 } from '@angular/core'
import { Platform } from '@angular/cdk/platform'
import { NgScrollbar } from 'ngx-scrollbar'
import { Subject } from 'rxjs'

@Directive({
  selector: '[linPerfectScrollbar]',
  standalone: false,
})
export class PerfectScrollbarDirective implements OnInit, AfterViewInit, OnDestroy {
  private mutationObserver: MutationObserver
  private update$ = new Subject<void>()

  constructor(
    private readonly renderer: Renderer2,
    private readonly element: ElementRef,
    private readonly platform: Platform,
    private readonly zone: NgZone,
    @Optional() private readonly ps: NgScrollbar,
  ) {}

  ngOnInit(): void {
    this.update$.subscribe(() => this.update())
  }

  ngAfterViewInit(): void {
    if (this.platform.ANDROID || this.platform.IOS) {
      this.renderer.addClass(this.element.nativeElement, 'default-scroll')
      return
    }

    // Initialize the perfect-scrollbar
    this.zone.runOutsideAngular(() => {
      // TODO: need to check
      // this.resizeObserver = new ResizeObserver(() => this.update$.next())
      // this.resizeObserver.observe(this.element.nativeElement)

      this.mutationObserver = new MutationObserver(() => this.update$.next())
      this.mutationObserver.observe(<Element>this.element.nativeElement, { childList: true, subtree: true })
    })
  }

  ngOnDestroy(): void {
    if (!this.ps) return
    // TODO: need to check
    // this.resizeObserver.disconnect()
    this.mutationObserver.disconnect()
    this.update$.complete()
  }

  update(): void {
    if (!this.ps) return
    this.zone.runOutsideAngular(() => this.ps.update())
  }
}
